/* eslint-disable react-refresh/only-export-components */
import AdicionarCompensacaoManualModal from '@/templates/ManutencaoDoPonto/CompensacaoManual/modals/AdicionarModal'
import EditarCompensacaoManualModal from '@/templates/ManutencaoDoPonto/CompensacaoManual/modals/EditarModal'
import ExcluirCompensacaoManualModal from '@/templates/ManutencaoDoPonto/CompensacaoManual/modals/ExcluirModal'
import NovoAbonoModal from '@/templates/ManutencaoDoPonto/Digitacao/modals/AdicionarAbonoDigitacao'
import DetalhesCompensacaoManual from '@/templates/ManutencaoDoPonto/Digitacao/modals/DetalhesCompensacaoManual'
import AdicionarTrocaAutomaticaHorario from '@/templates/ManutencaoDoPonto/TrocaAutomaticaHorario/Adicionar'
import EditarTrocaAutomaticaHorario from '@/templates/ManutencaoDoPonto/TrocaAutomaticaHorario/Editar'
import ExcluirTrocaAutomaticaHorario from '@/templates/ManutencaoDoPonto/TrocaAutomaticaHorario/Excluir'
import ViewHorarios from '@/templates/ManutencaoDoPonto/TrocaAutomaticaHorario/ViewHorarios'
import { CalculoProvider } from 'context/Calculo'
import React from 'react'
import { RouteObject } from 'react-router-dom'
import AprovarAjusteModal from 'templates/ManutencaoDoPonto/Ajuste/atoms/modals/Aprovar'
import AprovarVariosAjustesModal from 'templates/ManutencaoDoPonto/Ajuste/atoms/modals/AprovarVarios'
import ReprovarAjusteModal from 'templates/ManutencaoDoPonto/Ajuste/atoms/modals/Reprovar'
import ReprovarVariosAjustesModal from 'templates/ManutencaoDoPonto/Ajuste/atoms/modals/ReprovarVarios'
import AdicionarAbonoModal from 'templates/ManutencaoDoPonto/Ausencias/modals/AdicionarAbono'
import AddAfastamentoModal from 'templates/ManutencaoDoPonto/Ausencias/modals/AdicionarAfastamento'
import AdicionarCompensacaoFeriado from 'templates/ManutencaoDoPonto/Ausencias/modals/AdicionarCompensacaoFeriado'
import AdicionarCompensacaoFolga from 'templates/ManutencaoDoPonto/Ausencias/modals/AdicionarCompensacaoFolga'
import AdicionarFaltaCadastradaModal from 'templates/ManutencaoDoPonto/Ausencias/modals/AdicionarFaltaCadastrada'
import EditarAbono from 'templates/ManutencaoDoPonto/Ausencias/modals/EditarAbono'
import EditarAfastamento from 'templates/ManutencaoDoPonto/Ausencias/modals/EditarAfastamento'
import EditarCompensacaoFolga from 'templates/ManutencaoDoPonto/Ausencias/modals/EditarCompensacaoFolga'
import EditarCompensacaoFeriado from 'templates/ManutencaoDoPonto/Ausencias/modals/EditarCompensaoFeriado'
import EditarFaltaCadastrada from 'templates/ManutencaoDoPonto/Ausencias/modals/EditarFaltaCadastrada'
import ExcluirAusencia from 'templates/ManutencaoDoPonto/Ausencias/modals/ExcluirAusencia'
import ExcluirCalculo from 'templates/ManutencaoDoPonto/CalculoPonto/excluir'
import BaterPontoModal from 'templates/ManutencaoDoPonto/Digitacao/modals/BaterPonto'
import DetalhesAbono from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesAbono'
import { DetalhesAfastamento } from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesAfastamento'
import DetalhesCompensacaoFeriado from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesCompensacaoFeriado'
import DetalhesCompensacaoFolga from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesCompensacaoFolga'
import DetalhesFaltaCadastradaDigitacao from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesFaltaCadastrada'
import { DetalhesRegistro } from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesRegistros'
import DetalhesTrocaDia from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesTrocaDia'
import NovaCompensacaoFeriado from 'templates/ManutencaoDoPonto/Digitacao/modals/NovaCompensacaoFeriado'
import NovaCompensacaoFolga from 'templates/ManutencaoDoPonto/Digitacao/modals/NovaCompensacaoFolga'
import NovaCompensacaoManual from 'templates/ManutencaoDoPonto/Digitacao/modals/NovaCompensacaoManual'
import NovaFaltaCadastradaDigitacao from 'templates/ManutencaoDoPonto/Digitacao/modals/NovaFaltaCadastrada'
import NovoAfastamentoModal from 'templates/ManutencaoDoPonto/Digitacao/modals/NovoAfastamento'
import NovoDSR from 'templates/ManutencaoDoPonto/Digitacao/modals/NovoDSR'
import NovoRegistroModal from 'templates/ManutencaoDoPonto/Digitacao/modals/NovoRegistro'
import NovaTrocaDiaTrabalho from 'templates/ManutencaoDoPonto/Digitacao/modals/NovoTrocaDiaTrabalho'
import AbrirFecharCompetencia from 'templates/ManutencaoDoPonto/FechamentoAberturaCompetencia/atoms/modais/AberturaFechamento'
import { ModalDetalhes } from 'templates/ManutencaoDoPonto/FechamentoAberturaCompetencia/atoms/modais/Detalhes'
import AdicionarImplantacao from 'templates/ManutencaoDoPonto/ImplantacaoBancoHoras/modal/Adicionar'
import ExcluirImplantacao from 'templates/ManutencaoDoPonto/ImplantacaoBancoHoras/modal/Excluir'
import EditarPagamento from 'templates/ManutencaoDoPonto/PagamentoHoras/modals/Editar'
import PagarTudo from 'templates/ManutencaoDoPonto/PagamentoHoras/modals/PagarTudo'
import AdicionarSobreaviso from 'templates/ManutencaoDoPonto/Sobreavisos/modals/Adicionar'
import ExcluirSobreaviso from 'templates/ManutencaoDoPonto/Sobreavisos/modals/Excluir'
import ExcluirTrocaDiaTrabalho from 'templates/ManutencaoDoPonto/TrocaDiaTrabalho/Excluir'
import AdicionarTrocaTabelaHorario from 'templates/ManutencaoDoPonto/TrocaTabelaHorario/Adicionar'
import EditarTrocaTabelaHorario from 'templates/ManutencaoDoPonto/TrocaTabelaHorario/Editar'
import ExcluirTrocaTabelaHorario from 'templates/ManutencaoDoPonto/TrocaTabelaHorario/Excluir'

const Ajuste = React.lazy(() => import('pages/Ajuste'))
const CompensacaoManual = React.lazy(() => import('pages/CompensacaoManual'))
const CalculoPonto = React.lazy(() => import('pages/CalculoPonto'))
const DigitacaoV2 = React.lazy(
    () => import('templates/ManutencaoDoPonto/Digitacao/pages/DigitacaoLayout'),
)
const FechamentoCompetencia = React.lazy(
    () => import('pages/FechamentoCompetencia'),
)
const Implantacao = React.lazy(() => import('pages/Implantacao'))
const PagamentoHoras = React.lazy(() => import('pages/PagamentoHoras'))
const Sobreaviso = React.lazy(() => import('pages/Sobreaviso'))
const TrocaDiaTrabalho = React.lazy(() => import('pages/TrocaDiaTrabalho'))
const TrocaTabelaHorario = React.lazy(() => import('pages/TrocaTabelaHorarios'))
const Ausencias = React.lazy(() => import('pages/Ausencias'))
const TrocaAutomaticaHorario = React.lazy(
    () => import('pages/TrocaAutomaticaHorario'),
)

const base = '/manutencao-ponto'

export const manutencaoPonto: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/ausencias',
            element: <Ausencias />,
            children: [
                {
                    path: base + '/ausencias/afastamento/adicionar',
                    element: <AddAfastamentoModal />,
                },
                {
                    path: base + '/ausencias/abono/adicionar',
                    element: <AdicionarAbonoModal />,
                },
                {
                    path: base + '/ausencias/compensacao-feriado/adicionar',
                    element: <AdicionarCompensacaoFeriado />,
                },
                {
                    path: base + '/ausencias/compensacao-folga/adicionar',
                    element: <AdicionarCompensacaoFolga />,
                },
                {
                    path: base + '/ausencias/afastamento/:id/editar',
                    element: <EditarAfastamento />,
                },
                {
                    path: base + '/ausencias/falta-injustificada/adicionar',
                    element: <AdicionarFaltaCadastradaModal />,
                },
                {
                    path: base + '/ausencias/falta-justificada/adicionar',
                    element: <AdicionarFaltaCadastradaModal />,
                },
                {
                    path: base + '/ausencias/falta-justificada/:id/editar',
                    element: <EditarFaltaCadastrada />,
                },
                {
                    path: base + '/ausencias/falta-injustificada/:id/editar',
                    element: <EditarFaltaCadastrada />,
                },
                {
                    path: base + '/ausencias/abono/:id/editar',
                    element: <EditarAbono />,
                },
                {
                    path: base + '/ausencias/compensacao-feriado/:id/editar',
                    element: <EditarCompensacaoFeriado />,
                },
                {
                    path: base + '/ausencias/compensacao-folga/:id/editar',
                    element: <EditarCompensacaoFolga />,
                },
                {
                    path: base + '/ausencias/:tipo/:id/excluir',
                    element: <ExcluirAusencia />,
                },
            ],
        },
        {
            path: base + '/ajustes-ponto',
            element: <Ajuste />,
            children: [
                {
                    path: base + '/ajustes-ponto/:tipo/:id/aprovar',
                    element: <AprovarAjusteModal />,
                },
                {
                    path: base + '/ajustes-ponto/:tipo/:id/reprovar',
                    element: <ReprovarAjusteModal />,
                },
                {
                    path: base + '/ajustes-ponto/:ids/reprovar',
                    element: <ReprovarVariosAjustesModal />,
                },
                {
                    path: base + '/ajustes-ponto/:ids/aprovar',
                    element: <AprovarVariosAjustesModal />,
                },
            ],
        },
        {
            path: base + '/calculo-ponto',
            element: <CalculoPonto />,
            children: [
                {
                    path: base + '/calculo-ponto/:id/excluir',
                    element: <ExcluirCalculo />,
                },
            ],
        },
        {
            path: base + '/digitacao',
            element: (
                <CalculoProvider>
                    <DigitacaoV2 />
                </CalculoProvider>
            ),
            children: [
                {
                    path: base + `/digitacao/bater-ponto`,
                    element: <BaterPontoModal />,
                },
                {
                    path: base + `/digitacao/registros/adicionar`,
                    element: <NovoRegistroModal />,
                },
                {
                    path: base + `/digitacao/registros/adicionar/:dia`,
                    element: <NovoRegistroModal />,
                },
                {
                    path: base + `/digitacao/registros/:registroId`,
                    element: <DetalhesRegistro />,
                },
                {
                    path: base + `/digitacao/afastamento/adicionar`,
                    element: <NovoAfastamentoModal />,
                },
                {
                    path: base + `/digitacao/afastamento/detalhes/:id`,
                    element: <DetalhesAfastamento />,
                },
                {
                    path: base + `/digitacao/abono/adicionar/:dia`,
                    element: <NovoAbonoModal />,
                },
                {
                    path: base + `/digitacao/abono/adicionar`,
                    element: <NovoAbonoModal />,
                },
                {
                    path: base + `/digitacao/abono/detalhes/:id`,
                    element: <DetalhesAbono />,
                },
                {
                    path: base + `/digitacao/dsr/adicionar/:dia`,
                    element: <NovoDSR />,
                },
                {
                    path:
                        base + `/digitacao/compensacao-feriado/adicionar/:dia`,
                    element: <NovaCompensacaoFeriado />,
                },
                {
                    path: base + `/digitacao/compensacao-folga/adicionar/:dia`,
                    element: <NovaCompensacaoFolga />,
                },
                {
                    path: base + `/digitacao/compensacao-manual/adicionar/:dia`,
                    element: <NovaCompensacaoManual />,
                },
                {
                    path: base + `/digitacao/compensacao-manual/adicionar`,
                    element: <NovaCompensacaoManual />,
                },
                {
                    path:
                        base + `/digitacao/falta-injustificada/adicionar/:dia`,
                    element: <NovaFaltaCadastradaDigitacao />,
                },
                {
                    path: base + `/digitacao/falta-justificada/adicionar/:dia`,
                    element: <NovaFaltaCadastradaDigitacao />,
                },
                {
                    path: base + `/digitacao/falta/detalhes/:id`,
                    element: <DetalhesFaltaCadastradaDigitacao />,
                },
                {
                    path: base + `/digitacao/compensacao-feriado/detalhes/:id`,
                    element: <DetalhesCompensacaoFeriado />,
                },
                {
                    path: base + `/digitacao/compensacao-folga/detalhes/:id`,
                    element: <DetalhesCompensacaoFolga />,
                },
                {
                    path: base + `/digitacao/troca-dia-trabalho/adicionar/:dia`,
                    element: <NovaTrocaDiaTrabalho disableSelects />,
                },
                {
                    path: base + `/digitacao/troca-dia-trabalho/detalhes/:id`,
                    element: <DetalhesTrocaDia />,
                },
                {
                    path: base + `/digitacao/compensacao-manual/detalhes/:id`,
                    element: <DetalhesCompensacaoManual />,
                },
            ],
        },
        {
            path: base + '/fechamento-competencia',
            element: <FechamentoCompetencia />,
            children: [
                {
                    path: base + '/fechamento-competencia/alterar',
                    element: <AbrirFecharCompetencia />,
                },
                {
                    path: base + '/fechamento-competencia/:id/detalhes',
                    element: <ModalDetalhes />,
                },
            ],
        },
        {
            path: base + '/banco-horas',
            element: <Implantacao />,
            children: [
                {
                    path: base + '/banco-horas/adicionar',
                    element: <AdicionarImplantacao />,
                },
                {
                    path: base + '/banco-horas/:id/excluir',
                    element: <ExcluirImplantacao />,
                },
            ],
        },
        {
            path: base + '/pagamento-horas',
            element: <PagamentoHoras />,
            children: [
                {
                    path: base + '/pagamento-horas/editar/:funcionarioId',
                    element: <EditarPagamento />,
                },
                {
                    path: base + '/pagamento-horas/adicionar',
                    element: <PagarTudo />,
                },
            ],
        },
        {
            path: base + '/sobreaviso',
            element: <Sobreaviso />,
            children: [
                {
                    path: base + '/sobreaviso/adicionar',
                    element: <AdicionarSobreaviso />,
                },
                {
                    path: base + '/sobreaviso/:id/excluir',
                    element: <ExcluirSobreaviso />,
                },
            ],
        },
        {
            path: base + '/troca-dia-trabalho',
            element: <TrocaDiaTrabalho />,
            children: [
                {
                    path: base + '/troca-dia-trabalho/adicionar',
                    element: <NovaTrocaDiaTrabalho />,
                },
                {
                    path: base + '/troca-dia-trabalho/excluir/:id',
                    element: <ExcluirTrocaDiaTrabalho />,
                },
            ],
        },
        {
            path: base + '/troca-tabela-horario',
            element: <TrocaTabelaHorario />,
            children: [
                {
                    path: base + '/troca-tabela-horario/adicionar',
                    element: <AdicionarTrocaTabelaHorario />,
                },
                {
                    path: base + '/troca-tabela-horario/:id/excluir',
                    element: <ExcluirTrocaTabelaHorario />,
                },
                {
                    path: base + '/troca-tabela-horario/:id/editar',
                    element: <EditarTrocaTabelaHorario />,
                },
            ],
        },
        {
            path: base + '/compensacao-manual',
            element: <CompensacaoManual />,
            children: [
                {
                    path: base + '/compensacao-manual/adicionar',
                    element: <AdicionarCompensacaoManualModal />,
                },
                {
                    path: base + '/compensacao-manual/:id/editar',
                    element: <EditarCompensacaoManualModal />,
                },
                {
                    path: base + '/compensacao-manual/:id/excluir',
                    element: <ExcluirCompensacaoManualModal />,
                },
            ],
        },
        {
            path: base + '/troca-automatica-horario',
            element: <TrocaAutomaticaHorario />,
            children: [
                {
                    path: base + '/troca-automatica-horario/adicionar',
                    element: <AdicionarTrocaAutomaticaHorario />,
                },
                {
                    path: base + '/troca-automatica-horario/:id/editar',
                    element: <EditarTrocaAutomaticaHorario />,
                },
                {
                    path: base + '/troca-automatica-horario/:id/excluir',
                    element: <ExcluirTrocaAutomaticaHorario />,
                },
                {
                    path: base + '/troca-automatica-horario/:id/preview',
                    element: <ViewHorarios />,
                },
            ],
        },
    ],
}
